import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {NgxJsonViewerModule} from 'ngx-json-viewer';
import {TuiDialogContext} from '@taiga-ui/core';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';

export interface JsonModalData {
  jsonData: unknown;
}

@Component({
  selector: 'app-json-modal',
  standalone: true,
  imports: [CommonModule, NgxJsonViewerModule],
  templateUrl: './json-modal.component.html',
})
export class JsonModalComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<void, JsonModalData>,
  ) {}

  get jsonData(): unknown {
    return this.context.data.jsonData;
  }
}
